<template>
  <b-col md="12" class="mb-3">
    <h6 class="package-title" v-translate>ELEMENTS INCLUDED OR OPTIONAL</h6>
    <ul class="list-group">
      <li class="list-group-item p-2" v-for="(detail, detailIndex) in extras" :key="detailIndex">
        <div style="display: contents;" v-if="detail.optional">
          <b-iconstack style="cursor: pointer;" @click="toggle(detailIndex)" class="mr-2" v-if="selectable">
            <b-icon icon="square" stacked />
            <b-icon icon="check" stacked v-if="isSelected(detailIndex)" scale="0.8" />
          </b-iconstack>
          <b-icon icon="x" class="mr-2" v-else/>
        </div>
        <b-icon icon="check" class="text-success mr-2" v-else />
        <span style="cursor: pointer;" @click="toggle(detailIndex)" v-if="selectable && detail.optional">
          {{detail.label}} (+{{detail.price}} {{ currency }})
        </span>
        <span v-else>
          {{detail.label}} (+{{detail.price}} {{ currency }})
        </span>
      </li>
    </ul>
  </b-col>
</template>

<script>
export default {
  name: 'PackageExtras',
  props: {
    value: {
      type: Array
    },
    currency: {
      type: String,
      required: true
    },
    extras: {
      type: Array,
      required: true
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: []
    }
  },
  methods: {
    isSelected (detailIndex) {
      return this.selected.indexOf(detailIndex) >= 0
    },
    toggle (detailIndex) {
      this.$emit('toggle', detailIndex)
      const index = this.selected.indexOf(detailIndex)
      if (index >= 0) this.selected.splice(index, 1)
      else this.selected.push(detailIndex)
    }
  }
}
</script>
